<template lang="pug">
div
  template(v-if="!this.vg1.includes(menu2)")
    .odd-box(@click="placeBet($event.target)" :class="cssClass")
      //- .odd.center
      template(v-if="['hdp','hdph','ou','ouh'].includes(mode)")
        .odd-point 
          span.ha(v-if="['hdp','hdph'].includes(mode)") {{ homeAway == 1 ? $t("m.ODD_Home") : $t("m.ODD_Away") }}
          template(v-if="['b','s'].includes(label)")
            template(v-if="details[mode][count][8] == 4.5")
              span.ha {{ homeAway == 1 ? $t("m.LOT_BIG") : $t("m.LOT_SMALL") }}
            template(v-else)
              span.ha {{ homeAway == 1 ? $t("m.ODD_Over") : $t("m.ODD_Under") }}
          template(v-else)
            span.ha(v-if="['ou','ouh'].includes(mode)") {{ homeAway == 1 ? $t("m.ODD_Over") : $t("m.ODD_Under") }}           

          span {{ showOdds(mode.toUpperCase(), homeAway, odds[7], odds[8]) }}
          //- div {{details[mode][count]}}
      template(v-else-if="['oe','oeh'].includes(mode)")
        .odd-point
          span.ha {{ homeAway == 1 ? $t("m.ODD_Odd") : $t("m.ODD_Even") }}
      template(v-else-if="['oxt','oxth'].includes(mode)")
        .odd-point
          span.ha {{ homeAway == 1 ? $t("m.ODD_Home") : homeAway == 2 ? $t("m.ODD_Away") : $t("m.ODD_Draw") }}
      template(v-else-if="['ml','mlh'].includes(mode)")
        //- .odd-point
        //-   span.ha {{ label }}
      template(v-else)
        .odd-point
          span.ha {{ label }}
      //- template(v-else-if="['ouoeo'].includes(mode)")
      //-   .odd-point {{ details[mode]['OO'][7] }}
      .odd-value(:class="valueClass") {{ value }}
  template(v-else)
    //- .bettype-col(v-if="[45, 46, 49].includes(menu2) && label") {{ $t("m.GH_" + label.toUpperCase()) }}
    //- //- .bettype-col(v-if="[50].includes(menu2) && label") {{ $t("m.GC_" + label.toUpperCase()) }}
    //- .bettype-col(v-if="[51].includes(menu2) && label") {{ $t("m.GX_" + label.toUpperCase()) }}
    //- .odds.odd-value(:class="valueClass" @click="placeBet($event.target)") {{ value }}
    template(v-if="[45, 46, 49].includes(menu2)")
      template(v-if="label == 'raceItem'")
        .odd-box(@click="placeBet($event.target)" :class="cssClass")
          .odd-value(:class="valueClass") {{ value }}
      template(v-else)
        .col
          .m-label-betype {{ $t("m.GH_" + label.toUpperCase()) }}
          .odd-box(@click="placeBet($event.target)" :class="cssClass")
            .odd-value(:class="valueClass") {{ value }}
    template(v-else-if="[51,56,57].includes(menu2)")
      template(v-if="label == 'marbleItem'")
        .odd-box(@click="placeBet($event.target)" :class="cssClass")
          .odd-value(:class="valueClass") {{ value }}
      template(v-else)
        .col
          .m-label-betype(v-if="menu2 == 56 || (menu2 == 57 && !label.includes('EF8_'))" ) {{ $t("m.CF_" + label.toUpperCase()) }}
          .m-label-betype(v-if="menu2 == 57 && label.includes('EF8_')" ) {{ $t("m." + label.toUpperCase()) }}
          .m-label-betype(v-if="menu2 == 51") {{ $t("m.GX_" + label.toUpperCase()) }}
          .odd-box(@click="placeBet($event.target)" :class="cssClass")
            .odd-value(:class="valueClass") {{ value }}
    template(v-else-if="[55].includes(menu2)")
        .col
          .m-label-betype(v-if="!!label") {{ $t("m.MA_" + label.toUpperCase()) }}
          .odd-box(@click="placeBet($event.target)" :class="cssClass")
            .odd-value(:class="valueClass") {{ value }}
    template(v-else-if="[50,54].includes(menu2)")      
      .m-label-betype(v-if="menu2 == 50") {{ $t("m.GC_" + label.toUpperCase()) }}
      .m-label-betype(v-if="menu2 == 54") {{ $t("m.GR_" + label.toUpperCase()) }}
      .odd-box(@click="placeBet($event.target)" :class="cssClass")
        .odd-value(:class="valueClass") {{ value }}
    template(v-else)
      .odd-box(@click="placeBet($event.target)" :class="cssClass")
        .odd-point
          span.ha(v-if="['hdp','hdph'].includes(mode)") {{ homeAway == 1 ? $t("m.ODD_Home") : $t("m.ODD_Away") }}
          span.ha(v-if="['ou','ouh'].includes(mode)") {{ homeAway == 1 ? $t("m.ODD_Over") : $t("m.ODD_Under") }} 
          span.ha(v-if="['oe','oeh'].includes(mode)") {{ homeAway == 1 ? $t("m.ODD_Odd") : $t("m.ODD_Even") }}
          //- span.ha(v-if="[45, 46, 49].includes(menu2) && label") {{ $t("m.GH_" + label.toUpperCase()) }}
        .odd-value(:class="valueClass") {{ value }}
</template>

<script>
import config from '@/config';
import naming from '@/library/_name';
import { EventBus } from '@/library/_event-bus.js';

export default {
  name: 'OddsItem',
  props: {
    details: {
      type: [Object, Array],
      // required: true
    },
    odds: {
      type: Array,
      required: true
    },
    idx: {
      type: String,
      required: true
    },
    typ: {
      type: String,
      default: ''
    },
    cls: {
      type: String,
      default: ''
    },
    dataType: {
      type: String,
      required: true
    },
    mode: {
      type: String,
      default: ''
    },
    count: {
      type: [Number, String],
      default: 0
    },
    homeAway: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      trigger: false,
      timer: null,
      old: null,
      dir: null,
      defStake: '',
      newPage: true
    };
  },
  computed: {
    vg1() {
      return config.vg1;
    },
    menu0() {
      return this.$store.getters.menu0;
    },
    menu1() {
      return this.$store.getters.menu1;
    },
    menu2() {
      return this.$store.getters.menu2;
    },
    menu3() {
      return this.$store.getters.menu3;
    },
    betType() {
      return this.$store.state.layout.menu3;
    },
    id() {
      return this.odds[3];
    },
    value() {
      return this.odds[this.idx];
    },
    cssClass() {
      if (this.dir !== null) {
        return this.dir;
      }
    },
    dv() {
      let idx = parseInt(this.idx);
      switch (this.dataType) {
        case '1': // HDP/OU
          idx = parseInt(this.idx) + 16;
          return parseFloat(this.odds[idx]);
        case '2': // OE/ML/1X2
          idx = parseInt(this.idx) + 16;
          return parseFloat(this.odds[idx]);
        default:
          return parseFloat(this.odds[idx]);
      }
    },
    valueClass() {
      const result = [];
      if (this.cls) {
        result.push(this.cls);
      }
      if (!this.allowBet) {
        result.push('nb');
      }
      if (this.value < 0) {
        result.push('negetive');
      }
      return result;
    },
    allowBet() {
      switch (this.dataType) {
        case '1':
          return this.odds[15] === 1;
        case '2':
          return this.odds[10] === 1;
        case '3':
          return this.odds[9] === 1;
        case '4':
          return this.odds[9] === 1;
        default:
          return false;
      }
    },
    pause() {
      switch (this.dataType) {
        case '1':
          return this.odds[14] === 1;
        case '2':
          return this.odds[9] === 1;
        case '3':
        case '4':
          return false;
        default:
          return true;
      }
    },
    mixParlay() {
      switch (this.dataType) {
        case "1": // HDP/OU
          return this.odds[13] == 1;
        case "2": // OE/ML/1X2
          return this.odds[8] == 1;
        case "3": // CS/DC...
          return this.odds[8] == 1;
        case "4": // OUTRIGHT
          return this.odds[8] == 1;
      }
      return false;
    }
  },
  watch: {
    dv(newVal, oldVal) {
      var nv = newVal;
      var ov = oldVal;
      if (nv == "" || nv == 0) {
        this.trigger = false;
        this.dir = null;
        return;
      } else {
        if (ov != nv) {
          this.trigger = true;
          if (nv < 0) {
            if (ov < nv) {
              this.dir = "decrease";
            } else {
              this.dir = "increase";
            }
          } else {
            if (ov > nv) {
              this.dir = "decrease";
            } else {
              this.dir = "increase";
            }
          }
          setTimeout(() => {
            this.trigger = false;
            this.dir = null;
          }, 10000);
        }
      }
      this.old = oldVal;
    },
    id(newVal, oldVal) {
      this.reset();
    },
    typ(newVal, oldVal) {
      this.reset();
    },
    betType(newVal, oldVal) {
      this.reset();
    },
    menu0() {
      this.reset();
    },
    menu1() {
      this.reset();
    },
    menu2() {
      this.reset();
    },
    menu3() {
      this.reset();
    }
  },
  methods: {
    reset() {
      this.trigger = false;
      this.old = null;
      this.dir = null;
    },
    placeBet(e) {
      // $(".odd-value").removeClass("selected-odds");
      // $(".odd").removeClass("selected-odds");
      if (this.allowBet) {
        if (this.$store.state.layout.betting.defaultStake == "0") {
          this.defStake = this.$store.state.layout.betting.defaultStakeAmount;
        } else {
          this.defStake = 5;
        }
        if (this.betType != "parlay") {
          setTimeout(() => {
            // $(e).addClass("selected-odds");
            // console.log($(e).closest('.odd').attr('class'))
            // $(e).closest('.odd').addClass("selected-odds");
          }, 10);
          if (EventBus.betSingle) {
            EventBus.betSingle(this.odds, this.typ, this.idx, this.value, this.betType, this.defStake, this.mixParlay, null, e);
          }
        } else {
          if (this.mixParlay) {
            // if (Object.keys(this.$store.state.betparlay).length + 1 <= config.parlayMaxTicket) {
              if (EventBus.betParlay) {
                // console.log(this.mixParlay);
                EventBus.betParlay(this.odds, this.typ, this.idx, this.value, this.betType, this.defStake);
              }
            // } else {
            //   this.$helpers.showDialog(this.$t("ui.action"), this.$t("error.maxParlayTicket"), "info");
            // }
          }
        }
      }
    },
    showOdds(bet_type, home_away, giving, odds) {
      return naming.ballDisplay3(odds, giving, home_away, bet_type, this);
    }
  }
};
</script>
